export const trackingPercentToEm = (percent: number): `${number}em` =>
  `${percent / 100}em`;
